import { useState, type RefObject } from "react";
import { type UseFormWatch, type UseFormSetValue } from "react-hook-form";
import { SectionTitle } from "@userFrontend/components/SectionTitle";
import { Accordion } from "@root/shared/components/Accordion";
import { SectionWithTitleAndLabel } from "@userFrontend/components/SectionWithTitleAndLabel";
import { Checkbox } from "@root/shared/components/Checkbox";
import { DocumentDescription } from "./uiParts/DocumentDescription";
import { type ViolationReportInputsValues } from "../../schema";
import * as styles from "./styles.css";

type Props = {
  // React Hook Form の watch 関数
  watch: UseFormWatch<ViolationReportInputsValues>;
  // React Hook Form の setValue 関数
  setValue: UseFormSetValue<ViolationReportInputsValues>;
  // セクションタイトル領域への ref（エラー時のスクロール用）
  containerRef?: RefObject<HTMLDivElement>;
};

/**
 * 違反行為に関する資料提出可否の確認コンポーネント
 * - 資料提出が可能かどうかをチェックボックスで選択
 * - アコーディオンで提出資料の例を表示
 */
export const DocumentSubmissionCheck = ({ watch, setValue, containerRef }: Props) => {
  // 資料提出可能フラグを取得
  const submittableFlag = watch("documentsSubmittable");

  const checkboxId = "document-submission-checkbox";

  // アコーディオンの開閉状態
  const [isOpened, setIsOpened] = useState(false);

  /**
   * アコーディオンのクリックハンドラ
   */
  const handleAccordionClick = () => {
    setIsOpened((prev) => !prev);
  };
  return (
    <>
      <SectionTitle text="違反行為に関する資料の提出" />
      <div className={styles.wrapper}>
        <div className={styles.inputOuter}>
          <SectionWithTitleAndLabel
            isRequired={false}
            title="違反行為に関する資料の提出は可能ですか？"
            containerRef={containerRef ?? null}
          >
            <div className={styles.checkboxOuter}>
              <label htmlFor={checkboxId} className={styles.label}>
                <Checkbox
                  id={checkboxId}
                  name="documentsSubmittable"
                  checked={submittableFlag}
                  onChange={(e) => setValue("documentsSubmittable", e.currentTarget.checked)}
                />
                <span className={styles.checkboxText}>可能</span>
              </label>
            </div>
          </SectionWithTitleAndLabel>
          <Accordion
            title="お送りいただきたい資料の例"
            isOpened={isOpened}
            onClick={handleAccordionClick}
          >
            <DocumentDescription />
          </Accordion>
        </div>
      </div>
    </>
  );
};
